import { render, staticRenderFns } from "./Presenciais.vue?vue&type=template&id=3a612204"
import script from "./Presenciais.vue?vue&type=script&lang=js"
export * from "./Presenciais.vue?vue&type=script&lang=js"
import style0 from "./Presenciais.vue?vue&type=style&index=0&id=3a612204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports